import { supabase } from "@/integrations/supabase/client";

export type AuthEventType =
  | "login_success"
  | "login_failure"
  | "logout"
  | "signup"
  | "password_reset_requested"
  | "password_changed"
  | "mfa_enrolled"
  | "mfa_verified"
  | "mfa_unenrolled"
  | "account_locked"
  | "captcha_failed";

interface LogAuthEventInput {
  event_type: AuthEventType;
  email?: string | null;
  user_id?: string | null;
  metadata?: Record<string, unknown> | null;
}

/**
 * Fire-and-forget audit log helper. Posts to the `log-auth-event` edge
 * function which writes to `public.auth_events` via service role. Never
 * throws — auth flows must not break if logging fails.
 */
export function logAuthEvent(input: LogAuthEventInput): void {
  try {
    void supabase.functions
      .invoke("log-auth-event", { body: input })
      .catch((err) => {
        console.warn("log-auth-event failed", err);
      });
  } catch (err) {
    console.warn("log-auth-event threw", err);
  }
}